import React, { useState, useEffect } from "react";
import Card from "./components/Card";
import PersonCard from "./components/PersonCard";
import { InputWithLabel } from "./components/Input";
import Select from "./components/Select";
import { Button } from "./components/Button";

const creatureTypes = ["ser humano", "ser elepe", "faustão", "waifu"];
const persons = [
  {
    name: "Marquitos Nunes",
    type: "ser humano",
    mission: "Ciência de dados e sua aplicação em saúde",
    bio:
      "Caros amigos, o comprometimento entre as equipes não pode mais se dissociar do remanejamento dos quadros funcionais."
  },
  {
    name: "Antonio Brito",
    type: "ser elepe",
    mission: "eu jogo habbo",
    bio:
      "Caros inimigos, o blablabla entre as equipes não pode mais se dissociar do remanejamento dos quadros funcionais."
  }
];

function App() {
  const [type, setType] = useState(creatureTypes[0]);
  const [name, setName] = useState("");
  const [mission, setMission] = useState("");
  const [bio, setBio] = useState("");

  const [currentPerson, setCurrentPerson] = useState(null);

  useEffect(() => {
    console.log("mudou o currentPerson para:", currentPerson);
  }, [currentPerson]);

  return (
    <div className="App">
      <Card
        title={"card generico"}
        content={
          <>
            {persons.map((person, index) => (
              <Button key={index} onClick={e => setCurrentPerson(person)}>
                {person.name}
              </Button>
            ))}
            <hr />
            <form
              onSubmit={e => {
                e.preventDefault();
                console.log({ type, name, mission, bio });
              }}
            >
              <InputWithLabel
                value={name}
                onChange={e => setName(e.target.value)}
                type="text"
                label="nome popular"
              />
              <Select
                value={type}
                onChange={e => setType(e.target.value)}
                options={creatureTypes}
                label="tipo"
              />
              <InputWithLabel
                value={mission}
                onChange={e => setMission(e.target.value)}
                type="text"
                label="objetivo da missão"
              />
              <InputWithLabel
                value={bio}
                onChange={e => setBio(e.target.value)}
                type="text"
                label="bio"
              />
              <InputWithLabel type="submit" />
            </form>
          </>
        }
      />
      {currentPerson !== null && <PersonCard person={currentPerson} />}
    </div>
  );
}

export default App;
